import {RoleEntity} from "@ots-frontend/ots-data";
import {BaseEntityMultiSelect, BaseEntityMultiSelectProps} from "../base-entity-multi-select";
import {useCallback} from "react";

export type BaseRoleMultiSelectProps = Omit<
  BaseEntityMultiSelectProps<RoleEntity>,
  'nameMapper'
>

export const BaseRoleMultiSelect = (props: BaseRoleMultiSelectProps) => {
  const nameMapper = useCallback((e: RoleEntity) => {
    return e.name;
  }, []);

  return <BaseEntityMultiSelect nameMapper={nameMapper} {...props} />;
};
